import {IconHeart, IconHeartFilled, IconPlayerPlay} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {memo, useCallback} from "react";
import useAddFavoriteGame from "../../../../../hooks/games/useAddFavoriteGame.hook";
import useDeleteFavoriteGame from "../../../../../hooks/games/useDeleteFavoriteGame.hook";
import {useAuthStore} from "../../../../../store/useAuth.store";
import {useMiniGames} from "../../../../../store/useMiniGames";

import styles from "./GameCardHome.module.css";

const GameCardHome = ({game, handleOpenGame}) => {
  const authStatus = useAuthStore(state => state.authStatus);
  const handleShowAuthModal = useAuthStore(state => state.handleShowAuthModal);
  const setFavoriteGames = useMiniGames(state => state.setFavoriteGames);
  const storeFavoriteGames = useMiniGames(state => state.favoriteGames);
  const {addFavoriteGame} = useAddFavoriteGame();
  const {deleteFavoriteGame} = useDeleteFavoriteGame();

  const isFav = storeFavoriteGames.some(f => f.game_id === game.id);

  const handleFavorite = useCallback(
    e => {
      e.stopPropagation();
      if (authStatus !== "authenticated") return handleShowAuthModal();
      setFavoriteGames(
        {id: game.id, provider: game.provider, game_provider: game.provider},
        addFavoriteGame,
        deleteFavoriteGame
      );
    },
    [authStatus, handleShowAuthModal, setFavoriteGames, game.id, game.provider, addFavoriteGame, deleteFavoriteGame]
  );

  return (
    <div
      className={styles.gameCard}
      onClick={() => handleOpenGame(game.id, game.provider)}
      role="button"
      tabIndex={0}
      onKeyDown={e => e.key === "Enter" && handleOpenGame(game.id, game.provider)}
    >
      <div className={styles.thumbnail}>
        <img
          src={game.icon}
          alt={game.name}
          key={game.id}
          className={styles.thumbnailImg}
          loading="lazy"
        />
        <div className={styles.gradientOverlay} />
        <div className={styles.hoverOverlay}>
          <div className={styles.playBtn}>
            <IconPlayerPlay
              size={20}
              fill="#000"
            />
          </div>
        </div>
        <button
          type="button"
          className={`${styles.favBtn} ${isFav ? styles.favActive : ""}`}
          onClick={handleFavorite}
          aria-label={isFav ? "Remove from favorites" : "Add to favorites"}
        >
          {isFav ? (
            <IconHeartFilled
              size={14}
              color="currentColor"
            />
          ) : (
            <IconHeart
              size={14}
              stroke={2}
              color="currentColor"
            />
          )}
        </button>
      </div>
      <div className={styles.cardFooter}>
        <span className={styles.gameName}>{game.name}</span>
        <span className={styles.providerName}>{(game.provider_display_name || "").toUpperCase()}</span>
      </div>
    </div>
  );
};

GameCardHome.propTypes = {
  game: PropTypes.object.isRequired,
  handleOpenGame: PropTypes.func.isRequired,
};

export default memo(GameCardHome);
